export default "__VITE_ASSET__BrdA3b05__"